import React from 'react';
import {connect} from 'react-redux'
import {Flex} from '/app/src/component';
import style from './style.css'
import { withRouter } from 'react-router-dom'
import Jibber from '/app/src/jibber'

import Post from './Post'
import * as FAQSelector from '/app/src/model/FAQ/selector';
import DateTime from '/app/src/lib/DateTime';
import Pagination from '/app/src/component/Pagination'

import {FeedbackModel, FAQModel} from '/app/src/model'
import {FeedbackSelector} from '/app/src/model'



class Posts extends Jibber {
    constructor(props){
        super(props);
        this._onPaginationClick = this._onPaginationClick.bind(this);
        this._onClickItem = this._onClickItem.bind(this);

        this.useState({
            selected: -1,
            currentPage: 1
        })
    }

    componentDidMount(){
        this.props.dispatchCurrentItem(null)
        this.props.dispatchFeedback('helpdesk', 1);
    }

    _onPaginationClick(index){
        this.props.dispatchFeedback('helpdesk', index)
        this.setSelected(-1)
        this.props.dispatchCurrentItem(null)
        this.setCurrentPage(index)
    }

    _onClickItem(faqId, selectedIndex) {
        this.props.dispatchFAQ(faqId)
        this.props.dispatchCurrentItem(faqId)
        this.setSelected(selectedIndex)
    }

    _renderFeedbacks() {
        const {feedbacks, questions, metas} = this.props;
        const {selected} = this.state;
        let feedbackCmps = []
        for (let i = 0; i < feedbacks.size; i++) {
            const faqId = feedbacks.getIn([i, 'system_id'])
            const question = questions.getIn([faqId, 'question']);
            const categoryId = questions.getIn([faqId, 'category_id']);
            const feedbackText = feedbacks.getIn([i, 'feedback'])
            const rating = feedbacks.getIn([i, 'rating'])

            let rawDateCreated = feedbacks.getIn([i, 'date_created'])
            rawDateCreated = rawDateCreated.split('T')[0]
            const dateCreated = DateTime.formatDate(rawDateCreated, 'yyyy-mm-dd')
            const feedbackId = feedbacks.getIn([i, 'id'])
            const isRead = metas.getIn([feedbackId, 'has_read']);
            const isSelected = selected === i

            feedbackCmps.push(
                <Post
                    { ...{
                        question,
                        feedbackText,
                        rating,
                        dateCreated,
                        isRead,
                        faqId,
                        categoryId,
                        isSelected
                    }}
                    key={i}
                    onClick={() => this._onClickItem(faqId, i)} />
            )
        }
        return feedbackCmps
    }

    _renderNoPosts() {
        return (
            <Flex className={style.NoPostsText} w='100%' h='100%' center>
                Du har inte fått någon feedback än.
            </Flex>
        )
    }

    render() {
        const {feedbacks, count} = this.props;
        const {currentPage} = this.state;
        return (
            <Flex column>
            <div className={style.PostListWrapper}>
                <Flex className={style.PostList} column h='100%' width='100%' shrink={0}>
                    {feedbacks.size === 0 ? this._renderNoPosts() : this._renderFeedbacks()}
                </Flex>
            </div>
            <Flex>
                {<Pagination marginTop='auto'
                    itemCounts={count}
                    itemPerPage={15}
                    currentPage={currentPage}
                    onClick={this._onPaginationClick}/>}
            </Flex>
            </Flex>
        )
    }
}
const {dispatcher: dispatchFeedback} = FeedbackModel.read();

const mapDispatchToProps = (dispatch, props) => {
    return {
        'dispatchFeedback': (systemType, index) => dispatch(dispatchFeedback(systemType, index)),
        'dispatchFAQ': (faqId) => dispatch(FAQModel.requestById(faqId)),
        'dispatchCurrentItem': (currentItem) => dispatch(FeedbackModel.setCurrentItem(currentItem))
    }
}

function mapStateToProps(state, ownProps) {
    let feedbacks = FeedbackSelector.getFeedbackInfo(state, 'helpdesk');
    const count = FeedbackSelector.getFeedbackCount(state);
    const questions = FAQSelector.getFAQs(state);
    const metas = FeedbackSelector.getUsermeta(state, 'helpdesk');

    const currentItem = FeedbackSelector.getCurrentItem(state);

    return { feedbacks, questions, count, metas, currentItem }
}


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Posts))



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/ClientChatSettings/FAQ/Helpdesk/Feedback/Posts/index.js